import { memo, useCallback, Ref, forwardRef } from 'react';
import classNames from 'classnames';
import Tooltip from '@picsart/rc/Tooltip';
import IconUndo from '@picsart/icons/IconUndo';
import IconRedo from '@picsart/icons/IconRedo';
import { useTranslator } from '@picsart/rc/services/localization';

import useStyles from './styles';
import UndoRedoButton from './UndoRedoButton';
import testIds from './testIds';

export enum UndoRedoTypes {
  UNDO = 'Undo',
  REDO = 'Redo',
}

interface IProps {
  step: number;
  historyLength: number;
  disabled: boolean;
  onClickHandler: (value: 1 | -1, type: UndoRedoTypes) => void;
  minStep?: number;
}

const UndoRedo = forwardRef(({
  step, historyLength, onClickHandler, disabled, minStep = -1,
}: IProps, ref: Ref<HTMLDivElement>) => {
  const classes = useStyles();
  const translate = useTranslator();

  const undo = useCallback(() => {
    onClickHandler(-1, UndoRedoTypes.UNDO);
  }, [onClickHandler]);

  const redo = useCallback(() => {
    onClickHandler(1, UndoRedoTypes.REDO);
  }, [onClickHandler]);

  return (
    <div data-testid={testIds.undoRedo} className={classes.root} ref={ref}>
      <div className={classNames(classes.buttonGroup, 'we-undoRedo')}>
        <Tooltip overlay={translate('Undo')} placement="top" offset={[0, 14]}>
          <span>
            <UndoRedoButton onClick={undo} icon={IconUndo} isActive={step > minStep && !disabled} />
          </span>
        </Tooltip>
        <Tooltip overlay={translate('Redo')} placement="top" offset={[0, 14]}>
          <span>
            <UndoRedoButton onClick={redo} icon={IconRedo} isActive={historyLength - 1 > step && !disabled} />
          </span>
        </Tooltip>
      </div>
    </div>
  );
});

export default memo(UndoRedo);
